module.exports = __webpack_public_path__ + "img/relocation_banner.60d22bfe.jpg";